import { Blockchain, Layer, Tap2Mine, TravelClub } from 'shared/ui/Icon';

export const tableOfContents = [
  { id: 'introduction', title: 'Introduction' },
  { id: 'role', title: 'Role of CIT in the CratD2C Ecosystem' },
  { id: 'characteristics', title: 'Key Characteristics of CIT' },
  { id: 'ecosystem', title: 'CIT within the CratD2C 12+1 Ecosystem' },
  { id: 'overview', title: 'Tokenomics Overview' },
  { id: 'emission', title: 'CIT Supply Emission Model' },
  { id: 'allocation', title: 'Supply Allocation' },
  { id: 'utility', title: 'CIT Utility' },
  { id: 'security', title: 'Security & Infrastructure' },
  { id: 'importance', title: 'Strategic Importance of CIT' },
  { id: 'future', title: 'Future Development' },
  { id: 'conclusion', title: 'Conclusion' },
];

export const menuItems = tableOfContents.map(({ id, title }) => ({ id, title }));

export const statCards = [
  { label: 'Token Symbol', value: 'CIT', accent: true },
  { label: 'Token Standard', value: 'D2C-20', accent: true },
  { label: 'Network', value: 'CratD2C MainNet' },
  { label: 'Maximum Supply', value: '30,000,000,000 CIT' },
];

export const overviewRows = [
  ['Token Symbol', 'CIT'],
  ['Token Standard', 'D2C-20'],
  ['Blockchain', 'CratD2C MainNet'],
  ['Contract Address', '0x365e2e7226532274FC23d3DF35bBa7378beFE58A'],
  ['Maximum Supply', '30,000,000,000'],
  ['Supply Model', 'Biennial 8-Layer Zig-Zag'],
  ['First Emission', '2026'],
];

export const characteristics = [
  {
    title: 'Ecosystem Engagement Token',
    description:
      'By combining gamification mechanics with token incentives, CIT transforms users into active participants in the growth and expansion of the CratD2C blockchain economy.',
  },
  {
    title: 'Gamified Incentive Model',
    description:
      'CIT integrates with Proof-of-Interaction (PoI) mechanics through Tap-2-Mine, rewarding real engagement.',
  },
  {
    title: 'Loyalty Reward Infrastructure',
    description: 'Projects and merchants building on CratD2C can issue CIT rewards to users.',
  },
  {
    title: 'Referral & Community Growth Engine',
    description: 'CIT powers the 3-level referral structure used across multiple ecosystem applications.',
  },
  {
    title: 'Ecosystem Utility Expansion',
    description:
      'CIT can be used for reward redemption, ecosystem upgrades, participation incentives, and governance participation in future modules.',
  },
];

export const ecosystemItems = [
  ['Layer-1 Blockchain', 'CIT rewards validator-community participation programs and ecosystem engagement.'],
  [
    'Tap-2-Mine (PoI Mining)',
    'Users earn CIT through <mark>participation in Proof-of-Interaction (PoI)</mark> and gamified ecosystem activities.',
  ],
  [
    'SEAV Protocol',
    'CIT powers reward multipliers and loyalty incentives within <mark>vault participation and ecosystem engagement.</mark>',
  ],
  [
    'Staking Protocol',
    'Delegators and Backers receive <mark>community engagement rewards in CIT</mark> for supporting network activity.',
  ],
  ['CratSwap V3', 'Liquidity mining programs and trading campaigns incorporate <mark>CIT reward incentives.</mark>'],
  ['E-Commerce Portal', 'Consumers earn <mark>CIT rewards for purchases</mark> within the decentralized marketplace.'],
  [
    'Real Estate Portal',
    'CIT rewards <mark>ecosystem referrals and marketplace participation</mark> within the property trading portal.',
  ],
  [
    'CRAT LuxePass Travel Club',
    'Travel, hospitality, and booking activities generate <mark>CIT loyalty rewards.</mark>',
  ],
  [
    'Universal Payment Gateway',
    'Merchants distribute <mark>CIT as customer loyalty incentives</mark> for payments processed through the network.',
  ],
  [
    'IP Blockchain Co-Ownership',
    'CIT rewards <mark>creators, innovators, and contributors</mark> participating in the intellectual property marketplace.',
  ],
  ['Smart-Swap Protocol', 'CIT incentivizes <mark>token conversion and ecosystem participation.</mark>'],
  ['Multi-Chain Bridge', 'Cross-chain ecosystem usage unlocks <mark>CIT engagement rewards.</mark>'],
  [
    'MainNet Explorer',
    'Community contributors participating in <mark>network monitoring, analytics, and ecosystem transparency programs</mark> receive CIT rewards.',
  ],
];

export const emissionRows = [
  ['Layer 1', '2026-2027', '20%', '6,000,000,000'],
  ['Layer 2', '2028-2029', '11.4%', '3,420,000,000'],
  ['Layer 3', '2030-2031', '8.6%', '2,580,000,000'],
  ['Layer 4', '2032-2033', '10.8%', '3,240,000,000'],
  ['Layer 5', '2034-2035', '5.2%', '1,560,000,000'],
  ['Layer 6', '2036-2037', '14.5%', '4,350,000,000'],
  ['Layer 7', '2038-2039', '11.8%', '3,540,000,000'],
  ['Layer 8', '2040-2041', '17.7%', '5,310,000,000'],
];

export const allocationRows = [
  { title: 'Community Engagement', amount: '10.5B', percent: 35, description: 'Tap-2-Mine, quests, user activity' },
  { title: 'Partners Incentives', amount: '4.5B', percent: 15, description: 'Growth & onboarding engine' },
  { title: 'Ecosystem & dApps', amount: '3.6B', percent: 12, description: 'Builders & integrations' },
  { title: 'Liquidity', amount: '3.0B', percent: 10, description: 'Market depth & stability' },
  { title: 'Foundation', amount: '3.0B', percent: 10, description: 'Strategic reserve' },
  { title: 'Team', amount: '2.4B', percent: 8, description: 'Long-term alignment' },
  { title: 'Marketing', amount: '1.5B', percent: 5, description: 'Long-term alignment' },
  { title: 'Staking/Lock', amount: '0.9B', percent: 3, description: 'Future utility' },
  { title: 'Treasury', amount: '0.6B', percent: 2, description: 'Risk buffer' },
];

export const allocationLeadText = 'The distributed supply supports ecosystem growth through the following categories:';

export const utilityItems = [
  [
    'DeFi Onboarding & Gamified Participation',
    'Seamless onboarding of Layer-2 projects while users earn rewards through interactive ecosystem participation.',
  ],
  ['Referral Rewards', 'Multi-level referral rewards use CIT.'],
  ['Loyalty Rewards', 'Merchants and platforms distribute CIT to users.'],
  ['Ecosystem Access', 'CIT can unlock premium features within ecosystem apps.'],
  ['Community Governance', 'Future governance modules may allow CIT holders to participate in community voting.'],
];

export const introActivities = [
  '<b>Layer-2 Onboarding</b>, where users and projects participate in the growth of DeFi, DApps, protocols, and applications building on CratD2C infrastructure',
  '<b>Tap-2-Mine Proof-of-Interaction</b>, where mobile engagement and interaction are rewarded through CIT',
  '<b>CRAT LuxePass Travel Club</b>, where premium travel membership, lifestyle loyalty, referral activity, and travel engagement generate Luxe Points and eligible rewards redeemable through CIT',
  '<b>Community Referral Campaigns</b>, designed to expand ecosystem awareness and adoption',
  '<b>CratD2C Applications and Services</b>, where engagement across the decentralized economy strengthens utility and participation',
];

export const utilityExpansionItems = [
  'reward redemption',
  'ecosystem upgrades',
  'participation incentives',
  'governance participation (future modules)',
];

export const securityItems = [
  'Compatibility with the CratD2C blockchain infrastructure',
  'Seamless integration with DeFi protocols',
  'High throughput transaction support',
  'Secure smart contract execution',
];

export const networkBenefitItems = [
  'Delegated Proof-of-Stake consensus',
  'Enterprise-grade validator infrastructure',
  'Ecosystem security audits',
];

export const strategicImportanceItems = [
  'the ecosystem rewards participation',
  'developers can incentivize adoption',
  'users remain active within the network',
];

export const futureDevelopmentItems = [
  'Tap-2-Mine global expansion',
  'SEAV Protocol engagement rewards',
  'DeFi incentive layers',
  'developer bounty programs',
  'ecosystem gamification modules',
];

export const textSections = [
  {
    id: 'introduction',
    title: 'Introduction',
    paragraphs: [
      'The <b>CRAT Impact Token (CIT)</b> is the gamified engagement and reward engine of the <b>CratD2C ecosystem</b>, created to drive user adoption, community growth, developer participation, and active interaction across the CratD2C 12+1 application economy.',
      'As a utility-driven asset, CIT turns meaningful ecosystem participation into measurable rewards. It supports users, communities, developers, and Layer-2 projects by encouraging onboarding, engagement, loyalty, and real ecosystem activity.',
      'CIT powers reward opportunities across key CratD2C experiences, including:',
      'By rewarding interaction, loyalty, onboarding, and ecosystem contribution, CIT bridges participation with value, helping CratD2C grow into a more active, connected, and utility-powered decentralized economy.',
    ],
  },
  {
    id: 'role',
    title: 'Role of CIT in the CratD2C Ecosystem',
    paragraphs: [
      'CIT functions as the loyalty and impact token of the ecosystem, complementing the $CRAT native coin.',
      'While $CRAT powers transactions, staking, governance, and payments, CIT rewards ecosystem participation.',
      'This dual-token design allows CratD2C to create a sustainable user incentive model without inflating the core settlement currency.',
    ],
  },
  {
    id: 'security',
    title: 'Security & Infrastructure',
    paragraphs: [
      'CIT is built on the CratD2C D2C-20 token standard, which ensures compatibility with the CratD2C blockchain infrastructure, seamless integration with DeFi protocols, high throughput transaction support, and secure smart contract execution.',
      'The network benefits from Delegated Proof-of-Stake consensus, enterprise-grade validator infrastructure, and ecosystem security audits.',
    ],
  },
  {
    id: 'importance',
    title: 'Strategic Importance of CIT',
    paragraphs: [
      'CIT plays a critical role in accelerating user growth and engagement.',
      'It ensures that the ecosystem rewards participation, developers can incentivize adoption, and users remain active within the network.',
      'This approach transforms the CratD2C ecosystem into a self-reinforcing economic network, where participation directly contributes to network expansion.',
    ],
  },
  {
    id: 'future',
    title: 'Future Development',
    paragraphs: [
      'The CIT ecosystem will continue evolving with the launch of Tap-2-Mine global expansion, SEAV Protocol engagement rewards, DeFi incentive layers, developer bounty programs, and ecosystem gamification modules.',
    ],
  },
  {
    id: 'conclusion',
    title: 'Conclusion',
    paragraphs: [
      'The CRAT Impact Token (CIT) represents the community engagement backbone of the CratD2C ecosystem.',
      'By combining gamification, loyalty incentives, and decentralized participation, CIT ensures that users, developers, and partners are actively involved in building the future of the CratD2C blockchain economy.',
      'Together with $CRAT, the CIT token helps establish a balanced, sustainable, and community-driven blockchain ecosystem capable of scaling globally.',
    ],
  },
];

export const getStartedItems = [
  {
    title: 'Earn. Convert. Trade. Grow.',
    description:
      'Experience the next level of blockchain engagement with CIT Token - your gateway to the CratD2C ecosystem.',
  },
  {
    title: 'CIT Token - Rewarding Every Interaction.',
  },
];

export const heroCards = [
  {
    title: 'Tap-2-Mine',
    description: 'Proof-of-Interaction mobile mining with mining reward paid in CIT',
    Icon: Tap2Mine,
    placement: 'topLeft',
    href: 'https://cratd2csmartchain.io/tap2mine',
  },
  {
    title: 'Layer-2 Onboarding',
    description: 'DeFi, DApps, protocols building on CratD2C Smart Chain',
    Icon: Layer,
    placement: 'bottomLeft',
    href: 'https://cratd2csmartchain.io/ecosystem',
  },
  {
    title: 'CRAT LuxePass Travel Club',
    description: 'Premium Travel Club, Lifestyle Rewards & Loyalty Economy with loyalty rewards redeemable in CIT',
    Icon: TravelClub,
    placement: 'topRight',
    href: 'https://cratluxepass.com/',
  },
  {
    title: 'CratD2C Blockchain',
    description: 'Interactive 12+1 applications built on the CratD2C infrastructure',
    Icon: Blockchain,
    placement: 'bottomRight',
    href: 'https://explorer.cratd2csmartchain.io/',
  },
] as const;
